<button class="back" (click)="clickEvent.emit($event)">{{label()}}</button>